'use client';

import { useState } from 'react';

import MinusIcon from '@/fo/icons/base/icons/minus.svg';
import PlusIcon from '@/fo/icons/base/icons/plus.svg';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';

import { styles } from './UiKitAccordionBase.styles';

export interface UiKitAccordionBaseProps {
  items: {
    header: React.ReactNode;
    content: React.ReactNode;
    disabled?: boolean;
  }[];
  defaultActiveIndexes?: number[];
}

export function UiKitAccordionBase({
  items,
  defaultActiveIndexes = []
}: UiKitAccordionBaseProps) {
  const slots = styles();

  const [activeIndexes, setActiveIndexes] = useState(defaultActiveIndexes);

  const handleOpen = (index: number) => () => {
    setActiveIndexes((prev) => [...prev, index]);
  };

  const handleClose = (index: number) => () => {
    setActiveIndexes((prev) => prev.filter((i) => i !== index));
  };

  return (
    <div className={slots.base()}>
      {items.map((item, index) => {
        const isOpen = activeIndexes.includes(index);

        return (
          <div
            className={slots.wrapper()}
            key={index}
          >
            <button
              className={slots.header()}
              onClick={isOpen ? handleClose(index) : handleOpen(index)}
            >
              {item.header}
              <span className={slots.headerIcon()}>
                {isOpen ? <MinusIcon /> : <PlusIcon />}
              </span>
            </button>
            <UiKitCollapseBase collapse={!isOpen}>
              <div className={slots.content()}>{item.content}</div>
            </UiKitCollapseBase>
          </div>
        );
      })}
    </div>
  );
}
